t = require('views/internal/teacup-with-helpers')('header_enterprise_license')

module.exports = t.renderable ({ enterpriseName, maxMembers, availableLicenses })->
  t.p '.u-bottom', ->
    t.format 'you-only-have-licenses-available', { enterpriseName, maxMembers, availableLicenses }
    t.a '.header-banner-link-left.quiet.js-dismiss-enterprise-license-banner', { href: "#", style: 'float: right' }, ->
      t.icon 'close'


// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_enterprise_license.coffee